import React, { ReactNode } from "react";
import { Box } from "@UI/Components/Box/Box";
import { Text } from "@UI/Components/Text/Text";
import { Heading } from "@UI/Components/Heading/Heading";
import { Carousel, CarouselProps } from "@UI/Components/Carousel/Carousel";

export interface RecommendationCarouselProps
  extends Omit<CarouselProps, "title"> {
  title?: ReactNode;
  subtitle?: ReactNode;
}

/**
 * RecommendationCarousel
 *
 * Domain-level carousel for Recommendations sections.
 * Extends the generic Carousel with:
 * - title: rendered in heading font (Jornada Sans Bold), xl (24px), gray.800
 * - subtitle: rendered in body font, sm (14px), gray.700
 * - Default slide width of 300px
 */
export const RecommendationCarousel = ({
  title,
  subtitle,
  slideWidth = "300px",
  children,
  ...props
}: RecommendationCarouselProps) => {
  const header =
    title || subtitle ? (
      <Box>
        {title && (
          <Box color="gray.800">
            <Heading
              as="h2"
              fontSize={["xl", null, "3xl"]}
              lineHeight="100%"
            >
              {title}
            </Heading>
          </Box>
        )}
        {subtitle && (
          <Text fontSize="md" color="gray.700">
            {subtitle}
          </Text>
        )}
      </Box>
    ) : undefined;

  return (
    <Carousel slideWidth={slideWidth} header={header} {...props}>
      {children}
    </Carousel>
  );
};
